<template>
  <SectionBox class="mandala-goal-template-form-activity-goal-item">
    <div class="pb-2 d-flex align-items-center">
      <slot name="prependName" />
      <ChangedBox />
      <MaterialIcon
        class="mr-2"
        icon="flag" />
      <span class="mandala-goal-template-form-activity-goal-item__name font-weight-bold">
        <BaseTextareaWithProvider
          v-if="hasEntryName"
          v-model="_value.name"
          name="行動目標名"
          placeholder="空白にするとメンバーが自由に行動目標名を設定できます"
          empty-str-to-null
          :rows="1"
          :max-rows="3"
          :response-errors="responseErrors"
          autocomplete="off" />
        <BaseTextareaWithProvider
          v-else
          value=""
          name="行動目標名"
          placeholder="空白にするとメンバーが自由に行動目標名を設定できます"
          empty-str-to-null
          :rows="1"
          :max-rows="3"
          :response-errors="responseErrors"
          disabled
          autocomplete="off" />
      </span>
    </div>
    <div class="mandala-goal-template-form-activity-goal-item__slider">
      <BaseSlider
        min="0"
        max="5"
        disabled />
      <div
        v-if="$scopedSlots.aboveSlider"
        class="mandala-goal-template-form-activity-goal-item__slider__above">
        <slot name="aboveSlider" />
      </div>
    </div>
  </SectionBox>
</template>

<script>
import SectionBox from '@/components/parts/SectionBox.vue'
import BaseSlider from '@/components/parts/BaseSlider.vue'
import ChangedBox from '@/components/parts/ChangedBox.vue'
import BaseTextareaWithProvider from '@/components/parts/BaseTextareaWithProvider.vue'
export default {
  components: {
    BaseTextareaWithProvider,
    BaseSlider,
    SectionBox,
    ChangedBox
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    responseErrors: {
      type: Object,
      default: () => {}
    },
    hasEntryName: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mandala-goal-template-form-activity-goal-item {
  &__name {
    font-size: 12px;
    width: 100%;
  }

  &__slider {
    position: relative;

    &__above {
      position: absolute;
      top: 30%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>